import { LoaderFunction, useLoaderData } from "react-router-dom";
import { getCheckout } from "../../../../common/api/decimal/methods/compareAndPurchase.ts";

export type CheckoutData = Required<
  Awaited<ReturnType<typeof getCheckout>>
>["data"];

export const myCartLoader: LoaderFunction = async () => {
  const checkout = await getCheckout();
  if (checkout.ok) {
    return checkout.data;
  }
  throw new Error("myCartLoader not ok");
};

export function useMyCartLoaderData() {
  return useLoaderData<CheckoutData>();
}
